import { Component, OnInit, NgZone, AfterViewInit } from "@angular/core";
import { AuthService } from "../../shared/services/auth.service";
import { CalendarService } from "../../shared/services/calendar.service";
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
// Calendar
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MenuItem} from 'primeng/api';

export interface Item { title: string; start: string;}

@Component({
  selector: "app-calender",
  templateUrl: "./calender.component.html",
  styleUrls: ["./calender.component.scss"],
})
export class CalenderComponent implements OnInit, AfterViewInit {
  private itemsCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  calenderForm: FormGroup;
  menuitems: MenuItem[];
  events: any[];
  options: any;
  eventInfo: any[];
  displayAdmin: boolean = false;
  
  constructor(
    public authService: AuthService,
    public calendarService: CalendarService,
    public router: Router,
    public ngZone: NgZone,
    private afs: AngularFirestore,
    private calenderAddEvent: FormBuilder,
    ) {
    const eventsCollection = afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid + '/events');
    this.itemsCollection = afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid + '/events');
    this.items = this.itemsCollection.valueChanges();
    }    
  
  ngOnInit() {
    //Calender Options and Plugins
    this.options = {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
      defaultDate: Date.now(),
      listDayFormat: true,
      selectable: true,
      editable: false,
      droppable: false,
      default: 'bootstrap',
      eventColor: '#3B86FF',
      eventTextColor: '#FFFFFF',
      businessHours: [ {daysOfWeek: [ 1, 2, 3, 4, 5 ], startTime: '09:00', endTime: '17:00' }],
      nowIndicator: true,
      header: {
        left: "prev,today,next",
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek,addEventButton',
      },
      dateClick: (e) => {
        console.log("Date clicked");
        console.log(e);
        this.calendarService.dateDetails(e);
        this.calenderForm.value.start = e.dateStr;
      },
      eventClick: (e) => {
        console.log("Event clicked");
        console.log(e);
        this.calendarService.eventDetails(e);
        console.log(this.eventInfo);
      },
    };  
  
    //Forms
    this.calenderForm = this.calenderAddEvent.group({
      title: '',
      start: '',
      end: '',
      description: ''
    });

    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();
  }

  ngAfterViewInit(){
    this.menuitems = [
      {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
      {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
      {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
  ]
  }

  adminContent(){
    if(this.authService.adminContent == true){
      this.displayAdmin = true;
    }else{
      this.displayAdmin = false;
    }
  }

  addEventForm(){
    this.calendarService.addFormEvent(this.calenderForm.value.title, this.calenderForm.value.start, this.calenderForm.value.end, this.calenderForm.value.description);
  }
}
